(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["suonama-chat-widget"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-sn-chat]');
    if (!root) return;
    const launcher = root.querySelector('.sn-chat__launcher');
    const panel = root.querySelector('.sn-chat__panel');
    const close = root.querySelector('[data-sn-chat-close]');
    const messages = root.querySelector('[data-sn-chat-messages]');
    const form = root.querySelector('[data-sn-chat-form]');
    const status = root.querySelector('[data-sn-chat-status]');
    const identity = root.querySelector('[data-sn-chat-identity]');
    const mediaInput = form.elements.media;
    const api = root.dataset.api.replace(/\/$/, '');
    const visitorKeyName = 'suonama_chat_visitor_v1';
    let visitorKey = localStorage.getItem(visitorKeyName);
    let ready = false;
    let timer;
    if (!visitorKey) {
      visitorKey = `guest:${crypto.randomUUID()}`;
      localStorage.setItem(visitorKeyName, visitorKey);
    }

    const safe = (value) => {
      const span = document.createElement('span');
      span.textContent = value || '';
      return span.innerHTML;
    };

    const visitorQuery = () => `visitor=${encodeURIComponent(visitorKey)}`;

    const createSession = async () => {
      const name = root.dataset.customerName || form.elements.customer_name?.value || 'Website visitor';
      const email = root.dataset.customerEmail || form.elements.customer_email?.value || '';
      const response = await fetch(`${api}/session`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ visitor_key: visitorKey, customer_name: name, customer_email: email, customer_language: root.dataset.language }),
      });
      if (!response.ok) throw new Error('session');
      ready = true;
      if (identity) identity.hidden = true;
    };

    const render = (items) => {
      if (!items.length) {
        messages.innerHTML = `<p class="sn-chat__welcome">${safe(window.SUONAMA_CHAT_WELCOME || 'Send us your vehicle model, OEM number or a clear photo description. SUONAMA will reply here.')}</p>`;
        return;
      }
      messages.innerHTML = '';
      items.forEach((item) => {
        const bubble = document.createElement('div');
        bubble.className = `sn-chat__bubble sn-chat__bubble--${item.sender === 'admin' ? 'admin' : 'customer'}`;
        if (item.media_url && /^https:\/\//i.test(item.media_url)) {
          const media = document.createElement((item.media_type || '').startsWith('video/') ? 'video' : 'img');
          media.className = 'sn-chat__media-content';
          media.src = item.media_url;
          if (media.tagName === 'VIDEO') { media.controls = true; media.playsInline = true; media.preload = 'metadata'; }
          else media.alt = item.media_name || '';
          bubble.appendChild(media);
        }
        const text = item.translated_body || item.body;
        if (text) bubble.appendChild(document.createTextNode(text));
        const time = document.createElement('span');
        time.className = 'sn-chat__time';
        time.textContent = new Date(item.created_at).toLocaleString();
        bubble.appendChild(time);
        messages.appendChild(bubble);
      });
      messages.scrollTop = messages.scrollHeight;
    };

    const loadMessages = async () => {
      if (!ready) return;
      const response = await fetch(`${api}/messages?${visitorQuery()}`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('messages');
      const data = await response.json();
      render(Array.isArray(data.messages) ? data.messages : []);
    };

    const openChat = async () => {
      panel.hidden = false;
      launcher.hidden = true;
      launcher.setAttribute('aria-expanded', 'true');
      try {
        if (root.dataset.customerName) await createSession();
        if (ready) await loadMessages();
        timer = window.setInterval(() => loadMessages().catch(() => {}), 5000);
      } catch (error) {
        status.textContent = 'Chat is temporarily unavailable.';
      }
    };

    const closeChat = () => {
      panel.hidden = true;
      launcher.hidden = false;
      launcher.setAttribute('aria-expanded', 'false');
      window.clearInterval(timer);
    };

    launcher.addEventListener('click', openChat);
    close.addEventListener('click', closeChat);
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const body = form.elements.body.value.trim();
      const media = mediaInput.files[0];
      if (!body && !media) return;
      if (media && media.size > 25 * 1024 * 1024) {
        status.textContent = root.dataset.fileTooLarge;
        return;
      }
      status.textContent = '';
      try {
        if (!ready) await createSession();
        const payload = new FormData();
        payload.append('visitor_key', visitorKey);
        payload.append('body', body);
        payload.append('source_language', root.dataset.language);
        if (media) payload.append('media', media);
        const response = await fetch(`${api}/messages`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body: payload,
        });
        if (!response.ok) throw new Error('send');
        form.elements.body.value = '';
        mediaInput.value = '';
        await loadMessages();
      } catch (error) {
        status.textContent = 'Message could not be sent. Please try again.';
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
